import { useCallback } from 'react';

import { boundActionsFactory } from '@/packages/redux-state/store';
import { type TViewMode } from '@/packages/redux-state/store/slices/listingLayout/slice';
import { activePinSelector } from '@/packages/redux-state/store/slices/mapControls/selectors/dumb';

import { useReduxState } from '../context/ReduxStoreContext';

const useBoundActions = boundActionsFactory(reduxActions => ({
  setViewMode: reduxActions.listingLayout.setViewMode,
  clearActivePin: reduxActions.mapControls.clearActivePin,
  setIsPageReloading: reduxActions.browserPage.setIsPageReloading,
}));

type TUseViewModeChange = (nextView: TViewMode) => Promise<void>;

export const useViewModeChange = (): TUseViewModeChange => {
  const boundActions = useBoundActions();

  const reduxStore = useReduxState();

  return useCallback(
    async (nextView: TViewMode) => {
      const activePin = activePinSelector(reduxStore.getState());

      /**
       * Браузеру тяжело перерисовывать все карточки при смене вида (если фризы).
       * Поэтому сначала переключаем на скелетон, а потом уже меняем вид.
       */
      boundActions.setIsPageReloading(true);

      boundActions.setViewMode(nextView);

      window.scrollTo({ top: 0 });

      if (activePin) {
        boundActions.clearActivePin();
      }

      setTimeout(() => {
        boundActions.setIsPageReloading(false);
      });
    },
    [boundActions, reduxStore],
  );
};
